// extracted by mini-css-extract-plugin
export default {"tooltip":"tx-tooltip_tooltip__el0Vc","button":"tx-tooltip_button__EE1La","id":"tx-tooltip_id__5FllT"};